import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAlertContext } from '../../context/alertContext';

function EditBlog(props) {
    function goToTop() {
        window.scroll(0, 0);
    }

    const { showAlert } = useAlertContext()
    const [editPitch, setEditPitch] = useState([]);

    useEffect(() => {
        const URL = 'https://tbc-backend.up.railway.app/pitch/getOne/'
        axios.get(URL + props.editId).then(response => {
            setEditPitch(response.data)
        }).catch(error => { console.log(error); })
    }, [props.editId]);

    const [updatePitch, setUpdatePitch] = useState({});

    const handleChangePitch = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setUpdatePitch(values => ({ ...values, [name]: value }))
    }
    const handleSubmitPitch = (event) => {
        event.preventDefault()
        const pitchUrl = 'https://tbc-backend.up.railway.app/pitch/update/'
        const headers = { "Content-Type": "application/json" }
        const data = {
            pitchTitle: updatePitch.title,
            pitchType: updatePitch.type,
            pitchDescp: updatePitch.descp,
        }
        axios.patch(pitchUrl + props.editId, data, { headers }).then((res) => {

            goToTop()
            showAlert('Your pitch has been updated', 'primary', '#info-fill')
            setUpdatePitch({});
        }).catch((err) => {
            goToTop()
            showAlert(`Pitch is Failed to update, Please Try Again (Note: Please re-fill all columns if any empty)`, 'warning', '#exclamation-triangle-fill')
            console.log(err);
        })
    }

    return (
        <section>
            <form className="container blog mb-5" onSubmit={handleSubmitPitch}>
                <div className="blog-form">
                    <div className="form-group">
                        <label className="control-label mb-2" htmlFor="title">
                            Update your Pitch Title:
                        </label>
                        <div >
                            <textarea
                                className="form-control"
                                id="title"
                                placeholder="Enter your Pitch Title"
                                onChange={handleChangePitch}
                                defaultValue={editPitch.pitchTitle}
                                value={updatePitch.title}
                                name="title"
                            />
                        </div>
                    </div>
                    <div className="form-group my-4">
                        <label className="control-label mb-2" htmlFor="type">
                            What is Pitch Type:
                        </label>
                        <div className="">
                            <textarea
                                className="form-control"
                                id="type"
                                placeholder="Enter your Pitch type"
                                onChange={handleChangePitch}
                                defaultValue={editPitch.pitchType}
                                value={updatePitch.type}
                                name="type"

                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="control-label mb-2" htmlFor="descp">
                            Update Your Pitch Description:
                        </label>
                        <div className="">
                            <textarea
                                className="form-control "
                                rows={8}
                                id="descp"
                                placeholder="Enter pitch description here"
                                onChange={handleChangePitch}
                                defaultValue={editPitch.pitchDescp}
                                value={updatePitch.descp}
                                name="descp"
                            />
                        </div>
                    </div>
                    <div className="mt-4 pb-4 form-group">
                        <div className="col-sm-offset-2 mb-sm-5 mb-md-0">
                            <button type="submit" className="pitchBtn mb-sm-5 mb-md-0"
                                data-bs-dismiss="modal" value="Post Your Pitch">Update Pitch</button>
                        </div>
                    </div>
                </div>
            </form>
        </section>
    );
}

export default EditBlog;
